// import { Amplify } from 'aws-amplify';
import { IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { CircleOutlined, Remove } from '@mui/icons-material';
import { v4 as uuidv4 } from 'uuid';

import { ReservationDateTimeListHeader } from './ReservationDateTimeListHeader';
import { ReservationFramesType } from '../types/ReservationFramesType';

const stateIcons = [<Remove key="remove" />, <Remove key="cancel" />, <CircleOutlined key="circle" />];

export function ReservationDateTimeList(props: any) {
  const reservationFrames: ReservationFramesType | null = props.reservationFrames;
  const dateFrom = new Date(props.from.slice(0, 4) + '/' + props.from.slice(4, 6) + '/' + props.from.slice(6, 8));
  const dateTo = new Date(props.to.slice(0, 4) + '/' + props.to.slice(4, 6) + '/' + props.to.slice(6, 8));
  const openingTime = Number(reservationFrames?.openingTime) || 0;
  const endTime = Number(reservationFrames?.endTime) || 0;
  const timeUnit = Number(reservationFrames?.timeUnit) || 60;

  function createCell(date: string, time: string) {
    const DateItem = reservationFrames?.dateList.find((item) => item.date === date);
    const stringState =
      DateItem?.closed === '1'
        ? 0
        : DateItem?.resavationQuotaList.find((item) => item.startTime === time)?.reservationKbn || '0';

    const state = Number(stringState);
    const isDisabled = state === 0 || state === 1; // stateが0または1の場合は受付不可能

    return (
      <TableCell
        key={uuidv4()}
        align="center"
        sx={{
          backgroundColor: isDisabled ? '#f0f0f0' : 'inherit', // 受付不可の時、背景色を薄グレーに設定
          borderRight: '1px solid #ddd', // 右側に縦線を追加
          borderBottom: '1px solid #ddd' // 下側に横線を追加
        }}
      >
        <IconButton
          className="text-primary"
          onClick={() => {
            props.onSelectFrame(date, time, timeUnit);
          }}
          disabled={state !== 2}
        >
          {stateIcons[state]}
        </IconButton>
      </TableCell>
    );
  }

  function createRow(time: string) {
    return (
      <TableRow
        key={uuidv4()}
        sx={{
          '& .MuiTableCell-root': {
            height: '10px',
            padding: '0',
            borderRight: '1px solid #ddd', // 右側に縦線を追加
            borderBottom: '1px solid #ddd' // 下側に横線を追加
          }
        }}
      >
        <TableCell key={uuidv4()} align="center">
          {time.slice(0, 2) + ':' + time.slice(2, 4)}
        </TableCell>
        {(() => {
          const items = [];
          for (let date = dateFrom; date <= dateTo; date = new Date(date.getTime() + 1000 * 60 * 60 * 24)) {
            items.push(
              createCell(
                date.getFullYear().toString().padStart(4, '0') +
                  (date.getMonth() + 1).toString().padStart(2, '0') +
                  date.getDate().toString().padStart(2, '0'),
                time
              )
            );
          }
          return <>{items}</>;
        })()}
      </TableRow>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ height: '100%' }}>
      <Table stickyHeader>
        <ReservationDateTimeListHeader from={props.from} to={props.to} />
        {(() => {
          const items = [];
          var time = openingTime;
          do {
            items.push(createRow(time.toString().padStart(4, '0')));
            time =
              (Math.floor(time / 100) + Math.floor(((time % 100) + timeUnit) / 60)) * 100 +
              (((time % 100) + timeUnit) % 60);
          } while (time < endTime);
          return <TableBody>{items}</TableBody>;
        })()}
      </Table>
    </TableContainer>
  );
}
